import { render, staticRenderFns } from "./ResponseType4.vue?vue&type=template&id=34335f5c&scoped=true&"
import script from "./ResponseType4.vue?vue&type=script&lang=js&"
export * from "./ResponseType4.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType4.vue?vue&type=style&index=0&id=34335f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34335f5c",
  null
  
)

export default component.exports